module.exports = __webpack_public_path__ + "img/research-institute.ef7144b4.png";